import { getUserInfoThunk, signInThunk, signOutThunk } from './thunks';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { history } from '../../router/BrowserRouter';
import { State } from './types';

const isLoggedIn = localStorage.getItem('auth_status') === 'Authenticated' ? true : false;

const initialState: State = {
    isLoggedIn,
    userId: null,
    fetchStatus: 'Idle',
    signingOut: false,
    signOutModal: false,
    accessToProtectedRoutes: !isLoggedIn,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setAccessToProtectedRoutes: (state, action: PayloadAction<boolean>) => {
            state.accessToProtectedRoutes = action.payload;
        },
        setSignOutModal: (state, action: PayloadAction<boolean>) => {
            state.signOutModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signInThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(signInThunk.fulfilled, (state, action) => {
                state.fetchStatus = 'Idle';
                state.accessToProtectedRoutes = false;
            })
            .addCase(signInThunk.rejected, (state) => {
                state.fetchStatus = 'Rejected';
            })
            .addCase(getUserInfoThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(getUserInfoThunk.fulfilled, (state, action) => {
                state.userId = action.payload;
                state.isLoggedIn = true;
                state.fetchStatus = 'Idle';
                state.accessToProtectedRoutes = false;
            })
            .addCase(getUserInfoThunk.rejected, (state) => {
                state.userId = null;
                state.isLoggedIn = false;
                localStorage.clear();
                state.fetchStatus = 'Rejected';
                state.accessToProtectedRoutes = true;
            })
            .addCase(signOutThunk.pending, (state) => {
                state.signingOut = true;
            })
            .addCase(signOutThunk.rejected, (state) => {
                state.signingOut = false;
            })
            .addCase(signOutThunk.fulfilled, (state) => {
                state.isLoggedIn = false;
                state.signingOut = false;
                state.signOutModal = false;
                state.userId = null;
                state.accessToProtectedRoutes = true;
            })
    }
})

export const {
    setIsLoggedIn,
    setSignOutModal,
    setAccessToProtectedRoutes,
} = authSlice.actions;